import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomPagination from '../../CustomPagination';
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link/Link';
import Loader from '../../../components/Common/Loader';
import CancelBookingModal from '../../CancelBookingModal/CancelBookingModal';
import CancelScheduledBookingModal from '../../CancelBookingModal/CancelScheduledBookingModal';

import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { openCancelBookingModal } from '../../../actions/siteadmin/modalActions';
import { openCancelScheduledBookingModal } from '../../../actions/siteadmin/modalActions';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { censorWord, decode } from '../../../helpers/queryEncryption';

import { ExportCsvIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './BookingList.css';

export class BookingList extends Component {
	static propTypes = {
		bookingDetails: PropTypes.object,
	}
	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			searchList: '',
			isRestrict: false,
		}
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode({});
		this.setState({ isRestrict });
	}

	handleKeywordSearch = debounce((searchList) => {
		const { bookingDetails: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList
		}
		this.setState(variables)
		refetch(variables)
	});

	paginationData = (currentPage) => {
		const { bookingDetails: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	createBookingButton = () => (
		<Link to={'/siteadmin/manual-bookings/create'} className={cx(bt.btnPrimary, bt.displayInlineBlock)}>
			<FormattedMessage {...messages.addNewLabel} />
		</Link>
	);

	handleCancel = (data) => {
		const { openCancelBookingModal, openCancelScheduledBookingModal } = this.props;
		if (['scheduled'].includes(data.status)) openCancelScheduledBookingModal(data)
		else openCancelBookingModal(data)
	}

	restrictExport = () => {
		showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
	};

	render() {
		const { bookingDetails, bookingDetails: { loading }, bookingType, isManualBooking } = this.props;
		const { formatMessage } = this.props.intl;
		const { currentPage, searchList, isRestrict } = this.state;

		let exportType = bookingType === 1 ? 'jobs' : 'schedule-jobs';
		if (isManualBooking) exportType = 'manual-bookings'

		return (
			<div>
				<CancelBookingModal />
				<CancelScheduledBookingModal />
				<div className={s.exportDisplay}>
					<div className={s.searchGroupContainer}>
						<div className={cx(s.searchInput, 'searchInputRTL')}>
							<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
						</div>
					</div>
					<div className={cx(s.exportTextSection)}>
						{
							bookingDetails?.getAllBookings?.results && bookingDetails?.getAllBookings?.results?.length > 0 && (isRestrict ? <a
								href={`#`} className={cx(s.exportTextContainer)} onClick={() => this.restrictExport()}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a> : <a
								href={`/export-admin-data?type=${exportType}&keyword=${searchList ? searchList : ''}`}
								className={cx(s.exportTextContainer)}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a>)
						}
						{isManualBooking && <>{this.createBookingButton()}</>}
					</div>
				</div>

				{
					loading && <Loader type="circle" />
				}
				{!loading &&
					<div className='tableOuterContainer'>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.id} /></th>
									<th scope="col"><FormattedMessage {...messages.userName} /></th>
									<th scope="col"><FormattedMessage {...messages.partnerName} /></th>
									<th scope="col"><FormattedMessage {...messages.category} /></th>
									<th scope="col"><FormattedMessage {...messages.bookingStatus} /></th>
									<th scope="col"><FormattedMessage {...messages.totalFare} /></th>
									<th scope="col"><FormattedMessage {...messages.details} /></th>
									{!isManualBooking && <th scope="col"><FormattedMessage {...messages.chatLabel} /></th>}
									<th scope="col"><FormattedMessage {...messages.action} /></th>
								</tr>
							</thead>
							<tbody>
								{
									bookingDetails?.getAllBookings?.results && bookingDetails?.getAllBookings?.results?.length > 0 && bookingDetails?.getAllBookings?.results?.map((item, index) => {
										let categoryName = item?.categoryDetails?.name || '-';
										return (
											<tr key={index}>
												<td data-label={formatMessage(messages.id)}>{item.id}</td>
												<td data-label={formatMessage(messages.userName)}>{capitalizeFirstLetter(isRestrict ? censorWord(decode(item?.userDetails?.encryptFirstName)) : decode(item?.userDetails?.encryptFirstName))}</td>
												<td data-label={formatMessage(messages.partnerName)}>{item?.partnerDetails?.encryptFirstName ? capitalizeFirstLetter(isRestrict ? censorWord(decode(item?.partnerDetails?.encryptFirstName)) : decode(item?.partnerDetails?.encryptFirstName)) : "-"}</td>
												<td data-label={formatMessage(messages.category)}>{categoryName}</td>
												<td data-label={formatMessage(messages.bookingStatus)}>{item.status && messages[item.status] ? formatMessage(messages[item.status]) : item.status}</td>
												<td data-label={formatMessage(messages.totalFare)}><CurrencyConverter from={item.currency} amount={item.userPayableFare} /></td>
												<td data-label={formatMessage(messages.details)}>
													<div>
														<Link to={'/siteadmin/' + (exportType) + '/view/' + item.id} className="actionLinkText"><FormattedMessage {...messages.view} /></Link>
													</div>
												</td>
												{!isManualBooking && <td data-label={formatMessage(messages.chatLabel)}>
													<div>
														{item.messageData && item.messageData.threadItemsCount > 0 ? <Link to={'/siteadmin/' + (exportType) + '/chat-message/' + item.id} className="actionLinkText"><FormattedMessage {...messages.view} /></Link> : "-"}
													</div>
												</td>}
												<td data-label={formatMessage(messages.action)}>
													<div>
														{
															['created', 'scheduled', 'arrived', 'approved', 'reviewed'].includes(item.status) ?
																<span onClick={() => this.handleCancel({ bookingId: item?.id, requestBy: "cancelledByUser", currentPage, reason: "other", status: item.status })} className={"actionLinkText"}>{formatMessage(messages.cancelButton)}</span>
																: '-'
														}
													</div>
												</td>

											</tr>
										)
									})
								}
								{
									!loading && bookingDetails?.getAllBookings?.results && bookingDetails?.getAllBookings?.results?.length == 0 && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					bookingDetails?.getAllBookings?.results && bookingDetails?.getAllBookings?.results?.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={bookingDetails.getAllBookings.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.users)}
						/>
					</div>
				}
			</div>
		)
	}
}

const mapState = (state) => ({});
const mapDispatch = {
	openCancelBookingModal,
	openCancelScheduledBookingModal,
	demoRestrictionEncode
};

export default compose(injectIntl,
	withStyles(bt, s),
	connect(mapState, mapDispatch),
)(BookingList);